import React, { useEffect, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import DateRangeIcon from "@mui/icons-material/DateRange";
import AddchartIcon from "@mui/icons-material/Addchart";
import {
  AppBar,
  Divider,
  Fade,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import { Label } from "@mui/icons-material";

export default function ListItemSams(open) {
  const [anchorEl, setAnchorEl] = useState(null);
  const plus = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const history = useNavigate();
  const goReservation = (go) => {
    history(go);
  };
  const handleIconClick = (path, e) => {
    goReservation(path);
    e.preventDefault();
    setAnchorEl(null);
  };

  return (
    <ListItem disablePadding sx={{ display: "block" }}>
      <ListItemButton
        sx={{
          minHeight: 48,
          justifyContent: open ? "initial" : "center",
          px: 2.5,
        }}
        onClick={(e) => handleIconClick("/sams/dashboard", e)}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: open ? 3 : "auto",
            justifyContent: "center",
          }}
        >
          <NewspaperIcon />
        </ListItemIcon>
        <ListItemText primary="물동량" sx={{ opacity: open ? 1 : 0 }} />
      </ListItemButton>
      <Typography
        sx={{
          marginLeft: 1.5,
          color: "#000000",
          fontSize: "0.8rem",
        }}
        variant="h6"
      >
        {open.open === false ? "물동량" : ""}
      </Typography>
      <ListItemButton
        sx={{
          minHeight: 48,
          justifyContent: open ? "initial" : "center",
          px: 2.5,
        }}
        onClick={(e) => handleIconClick("/sams/cimplist", e)}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: open ? 3 : "auto",
            justifyContent: "center",
          }}
        >
          <DateRangeIcon />
        </ListItemIcon>
        <ListItemText primary="C-IMP List" sx={{ opacity: open ? 1 : 0 }} />
      </ListItemButton>
      <Typography
        sx={{
          marginLeft: 1.5,
          color: "#000000",
          fontSize: "0.8rem",
        }}
        variant="h6"
      >
        {open.open === false ? "C-IMP" : ""}
      </Typography>
      <ListItemButton
        sx={{
          minHeight: 48,
          justifyContent: open ? "initial" : "center",
          px: 2.5,
        }}
        onClick={(e) => handleIconClick("/sams/sphList", e)}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: open ? 3 : "auto",
            justifyContent: "center",
          }}
        >
          <AddchartIcon />
        </ListItemIcon>
        <ListItemText primary="보냉물동량" sx={{ opacity: open ? 1 : 0 }} />
      </ListItemButton>
      <Typography
        sx={{
          color: "#000000",
          fontSize: "0.8rem",
          textAlign: "center",
        }}
        variant="h6"
      >
        {open.open === false ? "보냉" : ""}
        <br />
        {open.open === false ? "물동량" : ""}
      </Typography>
    </ListItem>
  );
}
